import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { getRequest, deleteRequest } from "../../apiWrapper";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import NotificationFormModal from "../../components/report/NotificationFormModal";
import NotificationReadListModal from "../../components/report/NotificationReadListModal";
import { toast } from "react-toastify";

Modal.setAppElement("#root");

const AdminNotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [teacherSummary, setTeacherSummary] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showReads, setShowReads] = useState(false);
  const [readsTarget, setReadsTarget] = useState(null);

  useEffect(() => {
    fetchNotifications();
    fetchTeacherSummary();
  }, []);

  const fetchNotifications = async () => {
    try {
      const data = await getRequest("notifications/list?includeRead=true&withCounts=true");
      setNotifications(data);
    } catch (err) {
      console.error("お知らせ取得エラー:", err);
    }
  };

  const fetchTeacherSummary = async () => {
    try {
      const data = await getRequest("notifications/unread-summary");
      setTeacherSummary(data);
    } catch (err) {
      console.error("講師別未読数取得エラー:", err);
    }
  };

  const handleEdit = (n) => {
    setEditing(n);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("本当にこのお知らせを削除しますか？")) return;
    try {
      await deleteRequest(`notifications/${id}`);
      toast.success("お知らせを削除しました");
      fetchNotifications();
      fetchTeacherSummary();
    } catch (err) {
      console.error("お知らせ削除エラー:", err);
      toast.error("削除に失敗しました");
    }
  };

  const handleNew = () => {
    setEditing(null);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    fetchNotifications();
    fetchTeacherSummary();
  };

  const handleShowReads = (id) => {
    setReadsTarget(id);
    setShowReads(true);
  };

  const handleCloseReads = () => {
    setShowReads(false);
    setReadsTarget(null);
  };

  return (
    <div className="p-6 pt-20 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">お知らせ管理</h1>
      <div className="flex justify-end mb-6">
        <button
          onClick={handleNew}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 flex items-center"
        >
          <FaPlus className="mr-2" /> 新規作成
        </button>
      </div>

      {/* 講師別未読件数 */}
      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <h2 className="text-lg font-semibold mb-3">講師別未読件数</h2>
        <ul>
          {teacherSummary.map((t) => (
            <li key={t.userid} className="flex justify-between py-1 border-b">
              <span>{t.teacherName}</span>
              <span>{t.unreadCount}件</span>
            </li>
          ))}
          {teacherSummary.length === 0 && (
            <li className="py-2 text-gray-500">全員既読です</li>
          )}
        </ul>
      </div>

      {/* お知らせ一覧 */}
      <div className="bg-white p-4 rounded-lg shadow-md">
        <h2 className="text-lg font-semibold mb-3">お知らせ一覧</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">タイトル</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">対象</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">作成日</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">既読数</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">未読数</th>
                <th className="px-4 py-2"></th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {notifications.map((n) => (
                <tr key={n.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{n.title}</td>
                  <td className="px-4 py-2 text-sm text-gray-700">{n.target_roles.join(", ")}</td>
                  <td className="px-4 py-2 text-sm text-gray-700">{new Date(n.published_at).toLocaleDateString()}</td>
                  {/* 既読数 */}
                  <td className="px-4 py-2 text-sm text-gray-700">
                    <button
                      onClick={() => handleShowReads(n.id)}
                      className="text-blue-600 hover:underline"
                    >
                      {n.read_count}名
                    </button>
                  </td>
                  {/* 未読数 = total_targets - read_count */}
                  <td className="px-4 py-2 text-sm text-gray-700">
                    {n.total_targets - n.read_count}名
                  </td>
                  <td className="px-4 py-2 text-right text-sm font-medium flex gap-2">
                    <button
                      onClick={() => handleEdit(n)}
                      className="text-indigo-600 hover:text-indigo-900"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleDelete(n.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showForm && (
        <NotificationFormModal initial={editing} onClose={handleCloseForm} />
      )}
      {showReads && (
        <NotificationReadListModal
          notificationId={readsTarget}
          onClose={handleCloseReads}
        />
      )}
    </div>
  );
};

export default AdminNotificationsPage;
